<template>
  <div>
  <div class="header">
    <h1>Contact</h1>
    <br />
    <p>
      We know that commodity processing, building menus, menu diversions, WBSCM,
      etc... can be tedious and at times confusing. We are here to help and will
      be happy to assist you! Please contact us any time!
    </p>
  </div>
  <div class="flex-container">
    <div class="item">
      <div class="photopat"></div>
      <div class="contactinfo">
        <p>Pat Kelley</p>
        <a href="mailto:pat.kelley@mpk-kpg.com"
          ><p>pat.kelley@mpk-kpg.com</p></a
        >
        <p>(859) 396-6039</p>
      </div>
    </div>
    <div class="item">
      <div class="photomary"></div>
      <div class="contactinfo">
        <p>Mary Kuhn, SNS</p>
        <a href="mailto:mary.kuhn@mpk-kpg.com"><p>mary.kuhn@mpk-kpg.com</p></a>
        <p>(502) 689-4514</p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
// .. is an alias to /src
export default {
  name: "Contact"
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: flex-start;
}
.item {
  flex: 0 0 auto;
  margin: 50px;
  font-weight: bold;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.3);
}

.photopat {
  background-image: url("../assets/default_profile.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
}

.photomary {
  background-image: url("../assets/default_profile.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
}

.contactinfo {
  background: #333;
  color: whitesmoke;
  padding: 10px;
}
.contactinfo p {
  margin: 0px;
}
.contactinfo > a {
  color: whitesmoke;
}
.header {
  margin-top: 20px;
  text-align: left;
}
</style>
